import { useEffect, useState } from 'react'

import { Modal } from '@/common/ui/Modal'
import { Button } from '@/common/ui/Form/Button'

import { BrandPicker, type BrandPickerValue } from './BrandPicker'

type BrandPickerDialogProps = {
    modalId: string
    title?: string
    value: BrandPickerValue
    onSave: (brand: BrandPickerValue) => void
    isSaving?: boolean
    error?: unknown
}

export const BrandPickerDialog = ({
    modalId,
    title = 'Бренд товара',
    value,
    onSave,
    isSaving = false,
    error,
}: BrandPickerDialogProps) => {
    const [draftBrand, setDraftBrand] = useState<BrandPickerValue>(value)

    useEffect(() => {
        setDraftBrand(value)
    }, [value])

    const handleSave = () => {
        if (isSaving) return
        onSave(draftBrand)
    }

    const isUnchanged = (draftBrand?.id ?? null) === (value?.id ?? null)

    return (
        <Modal id={modalId} modalClassName='md:w-2xl max-w-none!'>
            <h3 className='mb-4 text-lg font-medium text-white'>{title}</h3>
            <BrandPicker value={draftBrand} onChange={setDraftBrand} />
            {Boolean(error) && (
                <div className='mt-3 text-center text-sm text-error'>
                    {error instanceof Error ? error.message : 'Не удалось сохранить бренд'}
                </div>
            )}
            <div className='mt-6 flex flex-col gap-2'>
                <Button
                    type='button'
                    className='w-full'
                    emphasis='accent'
                    size='xl'
                    onClick={handleSave}
                    disabled={isSaving || isUnchanged}
                    loading={isSaving}
                >
                    Сохранить
                </Button>
                <Button as='label' htmlFor={modalId} className='w-full' emphasis='secondary' size='lg' variant='ghost'>
                    Отмена
                </Button>
            </div>
        </Modal>
    )
}
